var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 18l6-6-6-6"}));
}

ChevronRightInline.defaultProps = {"className":"stroke","viewBox":"0 0 24 24"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
